// The reusable Firestore CRUD base now lives in the shared `@upadelmatch/core`
// package. We bind it to clubmanager's own `db` + `logger` once
// (`configureFirestore`), then re-export the generic class so the ~21 domain
// repositories keep `extends FirestoreRepository<typeof Schema>` with an
// unchanged `super(path, schema)` constructor. The binding runs at module eval,
// before any repository method is called (constructors only store path+schema).
import { db } from './client'
import { logger } from '@/core/logger'
import { configureFirestore, FirestoreRepository } from '@upadelmatch/core/firestore-repository'

configureFirestore({ db, logger })

export { FirestoreRepository }
